import { withStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme/';

export default withStyles((theme) => ({
  wrapper: {
    boxShadow: variables.shadows[1],
    borderRadius: '4px',
    overflow: 'hidden',
    backgroundColor: '#fff',
  },
  scroll: {
    overflowX: 'auto',
    width: '100%',
    padding: '0 1.5rem 1rem 1.5rem',
  },
  title: {
    fontSize: 16.5,
  },
  subTitle: {
    fontSize: 11,
    color: '#586375',
  },
  inline: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  content: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  table: {
    width: '100%',
    minWidth: 1000,
    backgroundColor: '#fff',
  },
  tableTitle: {
    backgroundColor: '#fff',
    padding: '1rem 1.5rem',
    borderRadius: '4px 4px 0 0',
    color: '#586375',
    fontSize: '0.875rem',
  },
  tableTitleText: {
    color: '#586375',
    fontSize: '1rem',
    fontWeight: 500,
  },
  tablePagination: {
    width: '100%',
    textAlign: 'right',
    padding: '10px 0',
    fontSize: 14,
    '& span.total': {
      [theme.breakpoints.down('sm')]: {
        display: 'block',
        width: '100%',
        padding: '12px 0',
        textAlign: 'center',
      },
    },
    '& button': {
      minHeight: 40,
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        width: '100%',
        margin: '0 !important',
        padding: '5px 0',
      },
    },
  },
  wallet: {
    height: '100%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  transferButton: {
    background: '#009358',
    color: 'white',
    [theme.breakpoints.down('sm')]: {
      float: 'none',
    },
    '&:hover': {
      background: '#007A49',
    },
    '&:disabled': {
      background: '#eee',
    },
  },
  // wallet inline
  walletInline: {
    height: '100%',
    padding: 0,
    boxShadow: variables.shadows[1],
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px',
      paddingBottom: 20,
    },
  },
  walletInlineContent: {
    height: '100%',
    padding: '0 !important',
  },
  walletInlineCode: {
    padding: '10px 0',
    background: '#f9f9f9',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      background: 'none',
      textAlign: 'left',
      padding: '5px 0',
    },
  },
  walletInlineValue: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-end',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    '& h2': {
      marginRight: 12,
      [theme.breakpoints.down('sm')]: {
        margin: 0,
      },
    },
  },
  walletInlineButton: {
    paddingRight: 20,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      marginTop: 8,
      textAlign: 'right',
    },
  },
  status: {
    width: '0.65rem',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: '4px 0 0 4px',
    background: '#ccc',
    '&.--Confirmada': {
      backgroundColor: variables.palette.secondary.main,
    },
    '&.--Cancelada': {
      backgroundColor: variables.palette.error.main,
    },
    '&.--Falhou': {
      backgroundColor: variables.palette.error.main,
    },
    '&.--Bloqueada': {
      backgroundColor: variables.palette.error.main,
    },
    '&.--Pendente': {
      backgroundColor: '#fabb0a',
    },
    '&.--Aguardando Retorno do Banco': {
      backgroundColor: '#fabb0a',
    },
    '&.--Em Processamento': {
      backgroundColor: '#fabb0a',
    },
    '&.--Aguardando Transferência': {
      backgroundColor: '#fabb0a',
    },
    '&.--Em Andamento': {
      backgroundColor: '#596375',
    },
    [theme.breakpoints.down('sm')]: {
      width: 16,
      height: 16,
      borderRadius: '100%',
      top: 'auto',
    },
  },
  moneyLabel: {
    display: 'flex',
    alignItems: 'center',
  },
}));
